import type { FC, ReactNode } from 'react';
import { useEffect } from 'react';
import * as S from './styles';
import { CloseIcon } from '../../../assets/icons/CloseIcon';
interface BottomSheetProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
}
export const BottomSheet: FC<BottomSheetProps> = ({
  isOpen,
  onClose,
  title,
  children
}) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  if (!isOpen) {
    return null;
  }
  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };
  const showHeader = Boolean(title && title.trim());
  return <S.Overlay isOpen={isOpen} onClick={handleOverlayClick} data-sentry-element="S.Overlay" data-sentry-component="BottomSheet" data-sentry-source-file="index.tsx">
      <S.Container isOpen={isOpen} data-sentry-element="S.Container" data-sentry-source-file="index.tsx">
        {showHeader && <S.Header>
            <S.Title>{title}</S.Title>
            <S.CloseButton onClick={onClose}>
              <CloseIcon />
            </S.CloseButton>
          </S.Header>}
        <S.Content hasHeader={showHeader} data-sentry-element="S.Content" data-sentry-source-file="index.tsx">{children}</S.Content>
      </S.Container>
    </S.Overlay>;
};
export default BottomSheet;